import { Outlet } from "react-router";
import {
  SidebarProvider,
  SidebarInset,
  SidebarTrigger,
  useSidebar,
} from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { AccountProvider } from "@/contexts/account-context";
import { ChevronRight } from "lucide-react";

/**
 * Barra de topo do celular, com o botao que abre o menu.
 *
 * No telefone a barra lateral vira uma gaveta fechada, e nao havia NADA que a
 * abrisse: o aplicativo inteiro ficava sem navegacao, so com a pagina atual. A
 * aba lateral abaixo nao resolvia, porque ela so aparece quando o estado e
 * "collapsed", que e um estado de desktop.
 *
 * Some a partir de `md`, onde a barra lateral volta a ser fixa e visivel.
 */
function BarraDoCelular() {
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-2 border-b bg-background/95 px-4 backdrop-blur md:hidden">
      <SidebarTrigger className="size-9" aria-label="Abrir menu" />
      <span className="font-semibold">SmartAds</span>
    </header>
  );
}

function SidebarExpandTab() {
  const { state, isMobile, toggleSidebar } = useSidebar();

  // No celular quem abre o menu e a barra de topo. Esta aba encostada na borda
  // esquerda disputaria o gesto de voltar do sistema.
  if (isMobile || state !== "collapsed") return null;

  return (
    <button
      onClick={toggleSidebar}
      className="fixed left-0 top-1/2 z-40 -translate-y-1/2 flex h-10 w-5 items-center justify-center rounded-r-md border border-l-0 bg-background/80 text-muted-foreground/50 backdrop-blur-sm transition-all hover:w-6 hover:text-muted-foreground hover:bg-background"
      aria-label="Expandir sidebar"
    >
      <ChevronRight className="size-3.5" />
    </button>
  );
}

export function AuthLayout() {
  return (
    <AccountProvider>
      <SidebarProvider>
        <AppSidebar />
        {/* `min-w-0` e a correcao de fundo do estouro horizontal.
            O `SidebarInset` e um item de flex, e item de flex tem
            `min-width: auto` por padrao: ele se recusa a encolher abaixo do
            conteudo. Uma tabela larga empurrava a largura da PAGINA, e o
            container de rolagem da propria tabela nunca entrava em acao. */}
        <SidebarInset className="min-w-0">
          <BarraDoCelular />
          <SidebarExpandTab />
          {/* Duas garantias contra rolagem horizontal da PAGINA.
              `min-w-0` deixa o conteudo encolher em vez de empurrar a largura.
              `overflow-x-clip` e a rede: nenhuma pagina consegue alargar o
              quadro, aconteca o que acontecer. Sem ela o navegador do celular
              reduz o zoom para caber, e tudo fica pequeno.

              `clip`, e nao `hidden`: `hidden` cria um container de rolagem e
              quebraria o `position: sticky` de dentro. Tabelas largas seguem
              rolando na propria caixa, que tem `overflow-x-auto`. */}
          <main className="min-w-0 flex-1 overflow-x-clip p-4 md:p-6">
            <Outlet />
          </main>
        </SidebarInset>
      </SidebarProvider>
    </AccountProvider>
  );
}
